"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callStatisticsTranslations = {
    "en": {
        totalCalls: "Total calls",
        calls: "Calls",
        immediatelyConnected: "Immediately connected",
        connectedAfterQueueing: "Connected after queueing",
        routedAway: "Routed away by pressing a digit",
        timedOut: "Timed out",
        abandoned: "Abandoned",
        failedDueToMaxCallers: "Failed due to max callers",
        callStatistics: "Call statistics",
        other: "Other",
    },
    "de": {
        connectedAfterQueueing: "Verbunden nach Wartezeit",
        timedOut: "Zeitüberschreitung",
        callStatistics: "Anrufstatistiken",
        immediatelyConnected: "Sofort verbunden",
        failedDueToMaxCallers: "Wegen Anrufer-Höchstzahl gescheitert",
        totalCalls: "Gesamtzahl der Anrufe",
        calls: "Anrufe",
        abandoned: "Abgebrochen",
        routedAway: "Durch Drücken einer Zahl fortgeleitet",
        other: "Andere",
    },
    "nl": {
        connectedAfterQueueing: "Verbonden na wachtrij",
        timedOut: "Verbroken",
        callStatistics: "Oproepstatistieken",
        immediatelyConnected: "Onmiddellijk verbonden",
        failedDueToMaxCallers: "Niet gelukt door maximaal aantal bellers",
        totalCalls: "Totale oproepen",
        calls: "Oproepen",
        abandoned: "Afgebroken",
        routedAway: "Doorsturen door nummer in te drukken",
        other: "Andere",
    },
    "it": {
        connectedAfterQueueing: "Collegata dopo attesa",
        timedOut: "Scaduta",
        callStatistics: "Statistiche chiamate",
        immediatelyConnected: "Collegata immediatamente",
        failedDueToMaxCallers: "Fallita a causa di massimo numero utenti",
        totalCalls: "Chiamate totali",
        calls: "Chiamate",
        abandoned: "Abbandonata",
        routedAway: "Dirottata premendo un numero",
        other: "Altro",
    },
    "fr": {
        connectedAfterQueueing: "Connecté après avoir fait la file",
        timedOut: "Interrompu",
        callStatistics: "Statistiques des appels",
        immediatelyConnected: "Connecté directement",
        failedDueToMaxCallers: "Échec dû au nombre maximum d'appelants",
        totalCalls: "Nombre total d'appels",
        calls: "Appels",
        abandoned: "Abandonné",
        routedAway: "Acheminé en appuyant sur un chiffre",
        other: "Autre",
    },
    "es": {
        connectedAfterQueueing: "Conectado después de estar en la cola",
        timedOut: "Tiempo agotado",
        callStatistics: "Estadísticas de llamada",
        immediatelyConnected: "Conectado de inmediato",
        failedDueToMaxCallers: "Error por exceso de llamadas",
        totalCalls: "Total de llamadas",
        calls: "Llamadas",
        abandoned: "Abandonado",
        routedAway: "Desviado al presionar un dígito",
        other: "Otro",
    },
    "ja": {
        connectedAfterQueueing: "キューイング後に接続した",
        timedOut: "タイムアウトした",
        callStatistics: "通話データ",
        immediatelyConnected: "即時接続した",
        failedDueToMaxCallers: "発信者数が最大のため失敗した",
        totalCalls: "合計通話数",
        calls: "通話",
        abandoned: "放棄された",
        routedAway: "数字を押してルーティングした",
        other: "その他の",
    },
    "en-GB": {
        connectedAfterQueueing: "Connected after queuing",
        timedOut: "Timed out",
        callStatistics: "Call statistics",
        immediatelyConnected: "Immediately connected",
        failedDueToMaxCallers: "Failed due to max callers",
        totalCalls: "Total calls",
        calls: "Calls",
        abandoned: "Abandoned",
        routedAway: "Routed away by pressing a digit",
        other: "Other",
    },
    "ru": {
        totalCalls: "Всего звонков",
        calls: "Звонки",
        immediatelyConnected: "Сразу соединены",
        connectedAfterQueueing: "Соединены после ожидания",
        routedAway: "Перенаправлены после нажатия кнопки",
        timedOut: "Не дождались",
        abandoned: "Отмененные",
        failedDueToMaxCallers: "Завершены из-за максимального количества звонящих",
        callStatistics: "Статистика по звонку",
        other: "Другие",
    },
};
